import { settings } from 'settings';
import Fetch from 'utils/fetch';
import Swal from 'sweetalert2';

export interface CourierPreferencesJson {
  courierId: number;
  targetNumberOfDeliveries: number;
  maxNumberOfDeliveries: number;
  endpoint?: {
    lon: number;
    lat: number;
  };
  endpointAddress?: string;
}

export async function fetchCourierPreferences(
  courierId: number
): Promise<CourierPreferencesJson> {
  const response: Response = await Fetch.get({
    url: `${settings.autobundlerUrl}/api/couriers/preferences/${courierId}`,
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch preferences, status code ${response.status}`
    );
  }
  return response.json();
}

export async function updateCourierPreferences(
  courierPreferences: CourierPreferencesJson
): Promise<string> {
  const response: Response = await Fetch.post({
    url: `${settings.autobundlerUrl}/api/couriers/preferences`,
    body: courierPreferences,
  });

  if (!response.ok) {
    throw new Error(
      `Failed to update preferences, status code ${response.status}`
    );
  }

  return response.text();
}

export const maybeUpdateCourierPreferences = async (
  newCourierPreferences: CourierPreferencesJson
) => {
  await updateCourierPreferences(newCourierPreferences).catch(err => {
    Swal.fire({
      title: 'Error!',
      icon: 'error',
      html: `<div>Error saving courier preferences: ${err}</div>`,
    }).catch(err2 => {
      /* Ignored (error showing an error...) */
      console.error(err);
      console.error(err2);
    });

    return false;
  });

  return true;
};
